import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class CheckBoxField extends Component {
  constructor() {
    super();
    this.checkbox = null;
    this.toggleState = this.toggleState.bind(this);
  }

  toggleState() {
    const { id, onChange } = this.props;
    const { checked } = this.checkbox;

    onChange(id, checked);
  }

  render() {
    const { id, children, className, checked } = this.props;
    const labelClassName = classNames('checkbox-field__custom-checkbox', 'needsclick',
      { 'checkbox-field__custom-checkbox--checked': checked });

    return (
      <div className={classNames('checkbox-field', className)}>
        <input
          type="checkbox"
          id={id}
          className="checkbox-field__system-checkbox"
          onChange={this.toggleState}
          ref={(ref) => { this.checkbox = ref; }}
          checked={checked}
        />
        <label htmlFor={id} className="checkbox-field__content needsclick">
          <div className={labelClassName}>
            {checked && <i className="material-icon material-icon--check needsclick" />}
          </div>
          <div className="checkbox-field__label needsclick">
            {children}
          </div>
        </label>
      </div>
    );
  }
}

CheckBoxField.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
};

export default CheckBoxField;
